// TODO: Refactor at least the name, as this is kind of a whole view
import { VStack } from '@chakra-ui/react';
import { useCategory } from 'hooks/api/backend/categories/getCategoryById';
import { ReactElement } from 'react';
import { SubfoldersStack } from 'components/common/SubfolderStack/SubfoldersStack';
import { SectionTitle, SectionVariant } from 'components/common/Sections/SectionTitle';
import { ArticleEntry } from 'components/common/ArticleEntry/ArticleEntry';
import { BaseArticle } from '@novaheal/types';
// import { useArticleModalContext } from './ArticleModalContext';

type Props = {
  id: string;
};

export const Category = ({ id }: Props): ReactElement => {
  const categoryQuery = useCategory(id);

  const hasSubfolders =
    categoryQuery.data && categoryQuery.data.subfolders && categoryQuery.data.subfolders.length > 0;
  const subfolders = categoryQuery.data?.subfolders;

  const hasArticles =
    categoryQuery.data && categoryQuery.data.articles && categoryQuery.data.articles.length > 0;
  const articles = categoryQuery.data?.articles;

  // const articleModalContext = useArticleModalContext();
  // const handleArticleClick = (articleId: string): void => {
  //   if (articleModalContext.onSelect) {
  //     articleModalContext.onSelect({
  //       // id: articleId,
  //       title: articles?.find((article) => article.id === articleId)?.title || '',
  //       description: articles?.find((article) => article.id === articleId)?.id || '',
  //       thumbnailUrl: articles?.find((article) => article.id === articleId)?.coverImageUrl || '',
  //     });
  //   }
  // };

  return (
    <VStack gap="4xl" align="left" width="100%" height="100%">
      {hasSubfolders && <SubfoldersStack folders={subfolders} />}
      {hasArticles && (
        <VStack
          alignItems="left"
          bg="background.primary"
          width="100%"
          p={{ base: '12px 16px', md: '20px' }}
          borderRadius={{ md: '2xl' }}
          gap="15px"
        >
          <SectionTitle variant={SectionVariant.ARTICLE} hasButton={false} />
          <VStack align="left" gap="3">
            {articles?.map((article: BaseArticle) => (
              // TODO replace articleEntry with dedicated component
              <ArticleEntry
                key={article.id}
                id={article.id}
                subtitle={article.folder || article.category.title}
                title={article.title}
                hasVideo={article.hasVideo}
                relevantYearNames={article.relevantYears}
                imageUrl={article.coverImageUrl}
                // onClick={() => handleArticleClick(article.id)}
              />
            ))}
          </VStack>
        </VStack>
      )}
    </VStack>
  );
};
